import api from "./Api";

class InutilizacaoNFCeService {
  GetInutilizacaoNFCe(payload) {
    return api.get("/v1/InutilizacaoNFCe/" + payload).then((response) => {
      return response.data;
    });
  }

  PostInutilizacaoNFCe(payload) {
    return api.post("/v1/InutilizacaoNFCe/", payload).then((response) => {
      return response.data;
    });
  }

  PutInutilizacaoNFCe(payload) {
    return api.put("/v1/InutilizacaoNFCe/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteInutilizacaoNFCe(payload) {
    return api.delete("/v1/InutilizacaoNFCe/" + payload).then((response) => {
      return response.data;
    });
  }

  GetInutilizacaoNFCeOData(payload) {
    return api.get("/OData/InutilizacaoNFCe" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new InutilizacaoNFCeService();
